/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPLAY_OBJ_CMS = 'GET_CURRENT_DISPLAY_OBJ_CMS';
export const GET_CURRENT_DISPLAY_DETAIL_OBJ_CMS =
  'GET_CURRENT_DISPLAY_DETAIL_OBJ_CMS';
export const GET_PLAN_TYPE_DATA_CMS = 'GET_PLAN_TYPE_DATA_CMS';
export const GET_REBATE_PROGRAM_CMS = 'GET_REBATE_PROGRAM_CMS';
export const GET_ERROR_MSG_CMS = 'GET_ERROR_MSG_CMS';
export const GET_FROM_CMS = 'GET_FROM_CMS';
export const SET_DISPLAY_OBJ_CMS = 'SET_DISPLAY_OBJ_CMS';
export const SELECT_OPTION = 'SELECT_OPTION';
export const GET_REBATE_PROGRAM_NAME_CMS = 'GET_REBATE_PROGRAM_NAME_CMS';
export const GET_CMS_REBATE_GROUP = 'GET_CMS_REBATE_GROUP';
export const GET_CMS_REBATE_GROUP_FREEZE_QTR =
  'GET_CMS_REBATE_GROUP_FREEZE_QTR';
export const GET_CMS_LIST_REBATE_GROUP = 'GET_CMS_LIST_REBATE_GROUP';
export const GET_CMS_REBATE_GROUP_NAME = 'GET_CMS_REBATE_GROUP_NAME';
export const GET_CMS_LIST_REBATE_GROUP_NAME = 'GET_CMS_LIST_REBATE_GROUP_NAME';
export const SET_REFRESH_DATA_CMS = 'SET_REFRESH_DATA_CMS';
export const SET_CMS_QUARTERLY_REPORTING = 'SET_CMS_QUARTERLY_REPORTING';
export const SET_AGENCY_INFO = 'SET_AGENCY_INFO';
export const SET_REFRESH_DATA_CMS_DISPLAY = 'SET_REFRESH_DATA_CMS_DISPLAY';
export const RESET_CMS_QUARTERLY_REPORTING = 'RESET_CMS_QUARTERLY_REPORTING';
export const SET_MAX_QTR_ONLOAD = 'SET_MAX_QTR_ONLOAD';
export const DISPATCH_FLAG = 'DISPATCH_FLAG';
export const SET_CMS_RPT_ADJ_SINGLE_RPC_QTR = 'SET_CMS_RPT_ADJ_SINGLE_RPC_QTR';
export const SET_CMS_RPT_GRP_RPC_QTR = 'SET_CMS_RPT_GRP_RPC_QTR';
